
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>회원 관리 - 회원 현황</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 삭제는 안되며 수정 버튼을 통해 사용 여부를 미사용으로 활용하면 됩니다.</p>
          </div>
          <button @click="toggleSearchPanel" class="Admin_toggleSearch_openBtn">
            검색
          </button>
          <div class="Admin_toggleSearchWrap" v-if="isPanelVisible">
            <div class="Admin_toggleSearcTit">
              <p>검색조건</p>
              <button class="Admin_toggleSearch_closeBtn" @click="toggleSearchPanel"></button>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="customer_name">고객명</label>
              <input
                  type='text'
                  id="customer_name"
                  placeholder = "고객명을 입력해주세요."
                  v-model="customer_name"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="customer_phone_number">전화번호</label>
              <input
                  type='text'
                  id="customer_phone_number"
                  placeholder = "전화번호를 입력해주세요."
                  v-model="customer_phone_number"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <button @click="fetchDataWithParams" class="Admin_toggleSearch_searchBtn">검색</button>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_session_admin,
  get_customer
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminCustomerManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      isPanelVisible: false,
      customer_name: '',
      customer_phone_number: '',
      admin_number: 0
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `
        /AdminCustomerManagementAdd?customer_ID=${this.tabulator.getSelectedData()[0].customer_ID}
        &customer_login_ID=${this.tabulator.getSelectedData()[0].customer_login_ID}
        `
      }
    },
    toggleSearchPanel: function () {
      this.isPanelVisible = !this.isPanelVisible
    },
    fetchDataWithParams: function () {
      const params = {
        customer_name: this.customer_name,
        customer_phone_number: this.customer_phone_number,
        admin_number: this.admin_number
      }
      get_customer(params).then(result_data => {
        this.tabulator.setData(result_data)
        this.tabulator.setPage(1)
      })
    }
  },
  mounted () {
    get_session_admin().then(result => {
      this.admin_number = result.admin_number
      const params = {
        customer_name: this.customer_name,
        customer_phone_number: this.customer_phone_number,
        admin_number: result.admin_number
      }
      get_customer(params).then(result_data => {
        this.tabulator = new Tabulator(this.$refs.table, {
          data: result_data,
          layout: 'fitData',
          pagination: 'local',
          paginationSize: 100,
          paginationButtonCount: 5,
          columns: [
            {formatter: 'rowSelection',
              titleFormatter: 'rowSelection',
              headerSort: false,
              cellClick: function (e, cell) {
                cell.getRow().toggleSelect()
              }
            },
            {title: 'ID', field: 'customer_ID', headerSort: false},
            {title: '가입구분', field: 'customer_division', headerSort: false},
            {title: '고객구분', field: 'customer_join_division', headerSort: false},
            {title: '로그인 ID', field: 'customer_login_ID', headerSort: false},
            {title: '고객명', field: 'customer_name', headerSort: false},
            {title: '전화번호', field: 'customer_phone_number', headerSort: false},
            {title: '이메일', field: 'customer_email', headerSort: false},
            {title: '성별', field: 'customer_gender', headerSort: false},
            {
              title: '포인트',
              field: 'point_log_point',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                let value = cell.getValue()
                return value !== null ? value.toLocaleString() + 'P' : '0P'
              }
            },
            {title: '관리자계정여부', field: 'customer_super_status', headerSort: false},
            {title: '사용여부', field: 'customer_activate', headerSort: false},
            {title: '탈퇴 사유', field: 'customer_secession_reason', headerSort: false},
            {title: '탈퇴 일자', field: 'customer_secession_date', headerSort: false},
            {title: '등록 일자', field: 'customer_registe', headerSort: false},
            {title: '수정 일자', field: 'customer_modified', headerSort: false}
          ]
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CustomerManagement/AdminCustomerManagement.vue